import { render } from "./GuiSquadStatusSelect.vue?vue&type=template&id=b935aba4"
import script from "./GuiSquadStatusSelect.vue?vue&type=script&lang=js"
export * from "./GuiSquadStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__